import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import Filter, { FilterValue } from 'components/Filter'
import Paper from 'components/Paper'
import { Table, TableHeader } from 'components/Table'
import { PaginationProps, usePagination } from 'components/Table/Pagination'
import { useSort } from 'components/Table/Sort'
import { calculatePagination } from 'providers/tanstack-query/utils'
import { DEFAULT_SORT, SORTABLE_COLUMNS } from './constants'
import { useColumns } from './hooks/useColumns'
import { BuildOrderForTable, BuildOrderSortBy, useGetBuildOrders } from './hooks/useGetBuildOrders'

export const BuildsPage = (): JSX.Element => {
  const { t } = useTranslation('features/history', { keyPrefix: 'builds' })
  const columns = useColumns()
  const [filters, setFilters] = useState<FilterValue[]>([])
  const { page, rowsPerPage, setPage, ...usePaginationProps } = usePagination({
    resetOnChange: [filters],
  })
  const { props: sortProps, sort } = useSort<BuildOrderForTable, BuildOrderSortBy>(
    DEFAULT_SORT,
    SORTABLE_COLUMNS,
  )

  const { buildOrders, count, loading } = useGetBuildOrders({
    ...calculatePagination({ page, rowsPerPage }),
    filters,
    sort,
  })

  const paginationProps: PaginationProps = {
    count,
    page,
    rowsPerPage,
    setPage,
    ...usePaginationProps,
  }

  const TableFilter = (
    <Filter
      id='buildsFilter'
      onChange={setFilters}
      placeholder={t('list.filter')}
      values={filters}
    />
  )

  return (
    <Paper>
      <TableHeader
        description={t('description')}
        filter={TableFilter}
        title={t('title')}
      />

      <GapBox />

      <Table<BuildOrderForTable>
        columns={columns}
        data={buildOrders}
        loading={loading}
        pagination={paginationProps}
        sort={sortProps}
      />
    </Paper>
  )
}
